<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

// Stats animation owns its own state since no other section needs it.
const stats = ref([
  { value: 0, target: 1460, suffix: '', label: 'לקוחות פעילים' },
  { value: 0, target: 25, suffix: '+', label: 'שנות ניסיון' },
  { value: 0, target: 24, suffix: '/7', label: 'שירות' },
  { value: 0, target: 20, suffix: '+', label: 'משאיות בשטח' },
])

let animationFrame = null

onMounted(() => {
  const animateStats = () => {
    stats.value.forEach((stat, index) => {
      const duration = 2000
      const startTime = performance.now()

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)

        const easeOut = 1 - Math.pow(1 - progress, 3)
        stat.value = Math.floor(easeOut * stat.target)

        if (progress < 1) {
          animationFrame = requestAnimationFrame(animate)
        }
      }

      setTimeout(() => {
        requestAnimationFrame(animate)
      }, index * 200)
    })
  }

  setTimeout(animateStats, 500)
})

onUnmounted(() => {
  if (animationFrame) {
    cancelAnimationFrame(animationFrame)
  }
})
</script>

<template>
  <section class="stats-section">
    <div class="container">
      <div class="stats-grid">
        <div v-for="stat in stats" :key="stat.label" class="stat-card">
          <span class="stat-value">{{ stat.value.toLocaleString() }}{{ stat.suffix }}</span>
          <span class="stat-label">{{ stat.label }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

@media (min-width: 768px) {
  .container {
    padding: 0 var(--spacing-lg);
  }
}

.stats-section {
  padding: var(--spacing-xl) 0;
  background: linear-gradient(180deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}

@media (min-width: 768px) {
  .stats-section {
    padding: var(--spacing-2xl) 0;
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-md);
}

@media (min-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: var(--spacing-lg);
  }
}

.stat-card {
  text-align: center;
  padding: var(--spacing-md);
}

@media (min-width: 768px) {
  .stat-card {
    padding: var(--spacing-lg);
  }
}

.stat-value {
  display: block;
  font-size: 1.75rem;
  font-weight: var(--font-weight-bold);
  background: linear-gradient(135deg, #d97706 0%, #f59e0b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: var(--spacing-xs);
}

@media (min-width: 768px) {
  .stat-value {
    font-size: clamp(2rem, 4vw, 3rem);
  }
}

.stat-label {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  font-weight: var(--font-weight-medium);
}

@media (min-width: 768px) {
  .stat-label {
    font-size: var(--font-size-sm);
  }
}
</style>
